import React from 'react';
import { Button, Space, Typography } from 'antd';

export const DocumentDownload: React.FC<{
  src: string;
  title: string;
}> = ({ src }) => {
  return (
    <Space direction="vertical" className="w-full gap-2 items-center">
      <Typography.Text>
        Não é possível reproduzir PDF neste dispositivo. Faça download do
        conteúdo clicando no botão abaixo.
      </Typography.Text>
      <Button
        href={src}
        target="_blank"
        rel="noopener noreferrer"
        type="primary"
      >
        Baixar conteúdo
      </Button>
    </Space>
  );
};
